export const getConversoesTempo = (state) => state.conversoesTempo.lista
export const getIsCarregandoListaConversoesTempo =
  (state) => state.conversoesTempo.isCarregandoLista
